// shadcn/ui's standard cn() helper. Combines clsx (conditional class names)
// with tailwind-merge (de-duplicates conflicting Tailwind utilities so e.g.
// `cn("px-2", "px-4")` produces "px-4" rather than both).

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
